<template>
    <div class="pb-5">
        <data-table ref="breeds"
                    :api-route="backendApiRoute"
                    :api-view-set="table.apiViewSet"
                    :name="table.name"
                    :columns="table.columns"
                    :search="table.search"
                    :filters="table.filters ? table.filters : []"
                    :actions="table.actions"
                    :orderings="table.orderings"
                    :initial-orderings="table.initialOrderings"
                    :row-actions="table.rowActions"
                    :key="table.key">
        </data-table>
    </div>
</template>

<script>
import DataTable from "@/components/Table/DataTable";
import {mapGetters} from "vuex";
import api from "@/api";
import actions from "@/components/Table/actions";
import {Municipality} from "@/pages/AppPages/Catalogs/Municipality/municipality";
import {Breed} from "@/pages/AppPages/Catalogs/Animals/breed";
export default {
    name: "BreedList",
    components: {DataTable},
    computed: {
        ...mapGetters(['ability']),
        backendApiRoute() { return api.breeds.default.list() },
    },
    data() {
        return {
            table: {
                name: 'breeds-table',
                apiViewSet: api.breeds.default,
                key: 'breeds-table',
                search: true,
                columns: [],
                orderings: [
                    'name',
                ],
                actions: [],
                rowActions: [],
                filters: [
                    { title: 'Вид', name: 'species', source: api.species.default.list()  },
                ]
            }
        }
    },
    mounted() {
        const canProceed = this.ability.can('update', 'Breed') || this.ability.can('update', 'Species')
        this.table.columns.push({
            name: 'name',
            title:  'Имя',
            alwaysVisible: true,
            to: {
                idColumn: 'id',
                routeName: 'breedDetail',
                prependWithN: false,
                restricted: !canProceed
            },
            extraDataFrom: 'species_object.name'
        })

        this.table.actions.push(
            actions.create(() => {
                    this.$router.push({name: 'breedCreate'})
                }, this.ability.can('create', 'Breed')
            )
        );

        if (this.ability.can('destroy', 'Breed')) {
            this.table.rowActions.push(
                new actions.objectDelete(Breed))
        }

    }

}
</script>

<style scoped>

</style>